import React from 'react';

/**
 * DecorativeBg — absolute background decorative circles used in sections
 *
 * Props:
 *  variant   'default' | 'warm' | 'subtle'
 *            default → orange top-right + yellow bottom-left
 *            warm    → orange top-right + yellow bottom-left + red center
 *            subtle  → lighter, smaller circles
 *
 * Always place inside a `relative overflow-hidden` parent section.
 *
 * Usage:
 *  <section className="py-12 bg-gradient-to-br from-gray-50 to-orange-50 relative overflow-hidden">
 *    <DecorativeBg />
 *    <div className="container mx-auto px-4 relative z-10">...</div>
 *  </section>
 */
const DecorativeBg = ({ variant = 'default' }) => {
  if (variant === 'warm') {
    return (
      <>
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-orange-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-yellow-300 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-red-300 rounded-full blur-3xl"></div>
        </div>
      </>
    );
  }

  if (variant === 'subtle') {
    return (
      <>
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-20 left-20 w-32 h-32 bg-orange-300 rounded-full"></div>
          <div className="absolute bottom-20 right-20 w-24 h-24 bg-yellow-300 rounded-full"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-red-300 rounded-full"></div>
        </div>
      </>
    );
  }

  // default
  return (
    <>
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-200 bg-opacity-20 rounded-full -translate-y-48 translate-x-48 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-yellow-200 bg-opacity-20 rounded-full translate-y-40 -translate-x-40 pointer-events-none"></div>
    </>
  );
};

export default DecorativeBg;
